import React from 'react';
const Plumber = () => <div className="service-page"><h1>Plumber</h1><p>Expert plumbing services for repairs, installations, and emergencies.</p></div>;
export default Plumber;
